import Vue from 'vue'

const copyComponent = (component, config) => {
    const copy = new (Vue.extend(component))(config)
    copy.$mount()
    return copy
}

export { copyComponent }
